/** Despite the name, this collapses to two rows on mobile resolutions */
export const TwoColumnInnerContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='grid grid-rows-[auto-fit_auto-fit] sm:grid-cols-[574px_330px] gap-8'>
      {children}
    </div>
  );
};
